import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  user: null,
}

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      // console.log("UserActions Payload:", action.payload);
      state.user = action.payload
    },
    clearUser: (state) => {
      state.user = null
    },
  },
})

export const { setUserDetails, clearUser } = userSlice.actions
export default userSlice.reducer
